<!--Conteneur principal affiché une fois l'abattement chargé-->
<div class="content" *ngIf="abattement">
    <!--En-tête de page avec titre, navigation retour et gestion des onglets-->
    <page-header [title]="getTitle()"
                 (onSelectedItemChange)="onSelectedItemChange($event)"
                 (onGoBack)="onGoBack()"
                 [listeItems]="listeTabItems">
    </page-header>

    <!--Contenu de l'onglet Généralités-->
    <div [hidden]="selectedItem?.code !== Onglets.GENERALITES">
        <!--Formulaire du détail abattement-->
        <form #form="ngForm">
            <!--Composant enfant portant les champs de saisie des généralités-->
            <indemnites-abattement-generalites
                [abattement]="abattement"
                [listeHoraires]="listeHoraires"
                [listeTypesEntite]="listeTypesEntite">
            </indemnites-abattement-generalites>
        </form>
    </div>

    <!--Bouton flottant pour les actions Enregistrer/Supprimer-->
    <floating-button [listeActions]="listeActions" [isPending]="isSaving"></floating-button>
</div>
<!--Indicateur de chargement tant que les données ne sont pas disponibles-->
<please-wait class="content" *ngIf="isLoading && !abattement"></please-wait>
